import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaBuilding,
  FaGlobeAsia,
  FaWifi,
  FaLeaf,
  FaRoad,
  FaUniversity,
  FaHandshake,
  FaChartLine,
  FaCity,
  FaAward
} from "react-icons/fa";
import "./giftabout.css";

const benefits = [
  {
    icon: <FaBuilding />,
    title: "Grade-A Offices",
    desc: "Premium commercial office infrastructure designed for global enterprises."
  },
  {
    icon: <FaUniversity />,
    title: "Financial Ecosystem",
    desc: "International Financial Services ecosystem supporting global businesses."
  },
  {
    icon: <FaCity />,
    title: "Smart Infrastructure",
    desc: "Technology-driven city with intelligent urban planning and utilities."
  },
  {
    icon: <FaWifi />,
    title: "Digital Connectivity",
    desc: "Reliable high-speed internet and advanced communication infrastructure."
  },
  {
    icon: <FaRoad />,
    title: "Excellent Connectivity",
    desc: "Easy access via road, rail and international airport."
  },
  {
    icon: <FaLeaf />,
    title: "Green Development",
    desc: "Environment-friendly infrastructure focused on sustainable growth."
  },
  {
    icon: <FaHandshake />,
    title: "Business Friendly",
    desc: "Simple regulations with policies that encourage business expansion."
  },
  {
    icon: <FaChartLine />,
    title: "Tax Advantages",
    desc: "Competitive tax and regulatory benefits wherever applicable."
  },
  {
    icon: <FaGlobeAsia />,
    title: "Global Ecosystem",
    desc: "Home to financial institutions, fintech companies and multinational firms."
  },
  {
    icon: <FaAward />,
    title: "Quality Lifestyle",
    desc: "World-class residential, education and lifestyle facilities."
  }
];

const Giftabout = () => {
  return (
    <div>
      <section className="gift-section">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8} className="text-center">
              <span className="gift-badge">WHY GIFT CITY?</span>

              <h2 className="gift-title">
                India's Premier Global Financial Hub
              </h2>

              <p className="gift-description">
                GIFT City is India's first operational smart financial and
                technology city designed for global businesses. It offers
                world-class infrastructure, international connectivity, premium
                commercial spaces, and a business-friendly regulatory
                environment that enables companies to scale confidently.
              </p>
            </Col>
          </Row>

          <Row className="g-4 mt-4">
            {benefits.map((item, index) => (
              <Col lg={4} md={6} key={index}>
                <div className="benefit-card">
                  <div className="benefit-icon">{item.icon}</div>

                  <h5>{item.title}</h5>

                  <p>{item.desc}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Giftabout;
